import { css } from '@eti/styles';
import { breakpoints } from '@etg/wings';
export const priceWrapperStyles = css`
  width: 100%;
`;
export const priceLabelStyles = css`
  margin-inline-start: auto;
  margin-top: auto;
`;
export const priceStyles = css`
  margin-inline-start: auto;
`;
export const animationProps = isMobile => ({
  animate: {
    height: 'auto',
    opacity: 1
  },
  transition: {
    type: 'tween',
    duration: isMobile ? 0.2 : 0
  }
});
export const standardGrid = css`
  column-gap: 8px;
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-template-rows: repeat(3, auto);

  @media (min-width: ${breakpoints._768}) {
    justify-content: end;
  }

  .priceLabel {
    grid-area: 2 / 2 / 2 / 3;
    margin-top: 0;

    @media (min-width: ${breakpoints._768}) {
      grid-area: 2 / 1 / 3 / 2;
      margin-top: 30px;
    }
  }

  &&:has(.addToCartButtonWrapper) .priceLabel {
    grid-area: 3 / 1 / 3 / 2;
    margin-top: 0;

    @media (min-width: ${breakpoints._768}) {
      grid-area: 2 / 1 / 3 / 2;
      margin-top: 8px;
    }
  }

  .price {
    grid-area: 3 / 2 / 3 / 3;
    margin-bottom: 8px;
    max-width: 21ch;
    overflow-wrap: break-word;
    text-align: end;

    @media (min-width: ${breakpoints._768}) {
      grid-area: 3 / 1 / 4 / 2;
      margin-bottom: 0;
      max-width: none;
    }
  }

  .selection {
    grid-area: 2 / 1 / 3 / 2;
    margin-bottom: 0;

    @media (min-width: ${breakpoints._768}) {
      grid-area: 1 / 2 / 2 / 3;
      margin-bottom: 8px;
    }
  }

  .buttonWrapper {
    grid-area: 3 / 1 / 4 / 3;
    width: auto;

    @media (min-width: ${breakpoints._768}) {
      grid-area: 2 / 2 / 4 / 3;
      width: max-content;

      label {
        max-width: 21ch;
        overflow-wrap: break-word;
      }
    }
  }

  legend {
    margin-inline-start: 0;
    text-wrap: wrap;
    width: 80%;

    @media (min-width: ${breakpoints._768}) {
      width: auto;
    }
  }

  .children {
    display: contents;
  }

  .validation {
    grid-area: 4 / 1 / 5 / 3;
    margin-top: 8px;

    @media (min-width: ${breakpoints._768}) {
      grid-area: 5 / 2 / 6 / 3;
    }
  }
`;
//# sourceMappingURL=styles.js.map